import React, { useState } from "react";

import Nav from "../../hooks/Nav";
import Tabs from "../../tailwindUI/Tabs";
import { ROLES } from "../../cognito/permissions/permission-maps";
import UpdateDocumentsDate from "../tools/UpdateDocumentsDate";
import Invoices from "./Invoices";
import WorkpaperTemplates from "./WorkpaperTemplates";
import { useLocation } from "react-router-dom";

import {
  DocumentArrowDownIcon,
  CurrencyDollarIcon,
  KeyIcon,
  CpuChipIcon,
  DocumentChartBarIcon,
  CogIcon,
} from "@heroicons/react/24/solid";
import { Admin } from "./Admin";
import { Agent } from "./Agent";
import { Settings } from "./Settings";

const modules = [
  {
    id: 1,
    name: "Documentos",
    icon: DocumentArrowDownIcon,
    current: false,
    href: "#fiscal-documents",
    allowedRoles: [ROLES.root, ROLES.help_desk],
  },
  {
    id: 2,
    name: "Facturas",
    icon: CurrencyDollarIcon,
    current: false,
    href: "#facturas",
    allowedRoles: [ROLES.root, ROLES.help_desk],
  },
  {
    id: 3,
    name: "Admin",
    icon: KeyIcon,
    current: false,
    href: "#admin",
    allowedRoles: [ROLES.root, ROLES.help_desk],
  },
  {
    id: 4,
    name: "Agente",
    icon: CpuChipIcon,
    current: false,
    href: "#agent",
    allowedRoles: [ROLES.root, ROLES.help_desk],
  },
  {
    id: 5,
    name: "Papeles de Trabajo",
    icon: DocumentChartBarIcon,
    current: false,
    href: "#workpapers",
    allowedRoles: [ROLES.root, ROLES.help_desk, ROLES.operationsManager],
  },
  {
    id: 6,
    name: "Settings",
    icon: CogIcon,
    current: false,
    href: "#settings",
    allowedRoles: [ROLES.root, ROLES.help_desk],
  },
];

const getModules = (hash) => {
  let currentModule = modules[0];
  if (hash) {
    currentModule = modules.find((module) => module.href === hash);
  }
  return modules.map((module) =>
    module.id === currentModule.id
      ? { ...currentModule, current: true }
      : module,
  );
};

function HelpDesk() {
  const { hash } = useLocation();
  const [tabs, setTabs] = useState(getModules(hash));
  const currentTab = tabs.find((tab) => tab.current)?.id;

  return (
    <div className="w-full flex flex-col min-h-screen">
      <div className="w-full">
        <Nav>
          <div className="text-white font-medium text-xl md:text-3xl xl:text-4xl flex gap-2 items-center">
            Help desk
          </div>
        </Nav>
      </div>
      <div className="w-full px-6 mt-24 lg:mt-0 flex-1 flex flex-col">
        <Tabs items={tabs} setItems={setTabs} />
        {currentTab === 1 && <UpdateDocumentsDate />}
        {currentTab === 2 && <Invoices />}
        {currentTab === 3 && <Admin />}
        {currentTab === 4 && <Agent />}
        {currentTab === 5 && <WorkpaperTemplates />}
        {currentTab === 6 && <Settings />}
      </div>
    </div>
  );
}

export default HelpDesk;
